import React from 'react'

const OilPressure_Old = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <g fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10}>
      <path d="M149.159 174.509h89.628M195.092 223.914V175.47M150.056 225.838h93.032v19.287h57.861c15.883 0 54.458-21.556 78.283-36.305 23.825-14.749 56.727-11.345 82.821 20.422l-29.498 31.767s-26.094-32.901-52.188-5.673-83.955 83.955-83.955 83.955H104.675s-12.48 0-12.48-23.825v-51.054l57.861-38.574z" />
      <path d="M120.916 240.207s-47.959-95.952-92.704-46.446c-38.648 42.761 32.072 75.92 66.937 69.206M470.862 329.894c-10.751 0-19.498-8.747-19.498-19.498 0-5.929 2.608-17.179 7.595-27.21 5.031-10.122 9.972-13.895 11.903-13.895s6.872 3.772 11.903 13.895c4.986 10.031 7.595 21.281 7.595 27.21 0 10.75-8.747 19.498-19.498 19.498z" />
    </g>
  </svg>
)
export default OilPressure_Old
